import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BrandOption } from '@app/models/brand-options'
import { CallSource } from '@app/models/call-source'
import { getEndpoint } from '@app/utils/get-endpoint'
import { Observable } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class BrandService {
	#brandService: string = 'Brand'
	#callSourceService: string = 'CallSource'

	constructor(private http: HttpClient) {}

	public getAllBrands(): Observable<BrandOption[]> {
		return this.http.get<BrandOption[]>(
			getEndpoint([this.#brandService, 'GetBrands'])
		)
	}

	public getAllCallSources(): Observable<CallSource[]> {
		return this.http.get<CallSource[]>(
			getEndpoint([this.#callSourceService, 'GetAllCallSources'])
		)
	}
}
